let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g2Hok")).then(() => parcelRequire('lS6Jx'));